import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Dialog, DialogTitle, DialogActions, Button } from '@material-ui/core';
import { CancelButton } from '~/modules/common/components';
import MergeResourceRequestDialogContent from './MergeResourceRequestDialogContent';

export const MergeResourceRequestDialog = ({
  open,
  onClose,
  resourceRequest,
  onMarkResourceRequestAsCompleteAndMerge,
  isMergeLoading
}) => {
  const resourceAllocationCount = (resourceRequest?.resourceAllocations || [])
    .length;

  const handleClick = useCallback(() => {
    onMarkResourceRequestAsCompleteAndMerge();
    if (!isMergeLoading) {
      onClose();
    }
  }, [isMergeLoading, onClose, onMarkResourceRequestAsCompleteAndMerge]);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        <FormattedMessage
          id="mergeResourceRequestDialog.mergeResourceTitle"
          values={{ count: resourceAllocationCount }}
        />
      </DialogTitle>
      <MergeResourceRequestDialogContent
        isLoading={isMergeLoading}
        resourceAllocationCount={resourceAllocationCount}
      />
      <DialogActions>
        <CancelButton onClick={onClose} disabled={isMergeLoading} />
        <Button color="primary" onClick={handleClick} disabled={isMergeLoading}>
          <FormattedMessage id="mergeResourceRequestDialog.acceptAndMerge" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

MergeResourceRequestDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  resourceRequest: PropTypes.object,
  onMarkResourceRequestAsCompleteAndMerge: PropTypes.func,
  isMergeLoading: PropTypes.bool
};

export default MergeResourceRequestDialog;
